const config = {
    messagingSenderId: MESSAGINGSENDERID
};

export default config;



// WEBPACK FOOTER //
// ./firebase.config.js